import React from 'react';
import { Helmet } from 'react-helmet-async';
const CancellationPage = () => {
  return <div className="bg-white" data-id="element-1072">
      <Helmet data-id="element-1073">
        <title data-id="element-1074">
          Driving Lesson Policies Northampton | Cancellations & Refunds
        </title>
        <meta name="description" content="Read Northampton Driving School's policies on bookings, cancellations, and refunds. Clear, fair, and transparent for every pupil." data-id="element-1075" />
        <meta name="keywords" content="driving lesson cancellation policy, Northampton driving school refunds, driving lesson booking terms" data-id="element-1076" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1077">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1078">
          Cancellation Policy
        </h1>
        <p className="mb-6" data-id="element-1079">
          At <span className="text-burgundy-600" data-id="element-1080">N</span>orthampton{' '}
          <span className="text-burgundy-600" data-id="element-1081">D</span>riving{' '}
          <span className="text-burgundy-600" data-id="element-1082">S</span>chool, we understand that
          circumstances can change. However, to maintain a fair and efficient
          service for all our students, we have implemented the following
          cancellation policy:
        </p>
        <section className="mb-8" data-id="element-1083">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1084">
            Standard Lessons
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1085">
            <li data-id="element-1086">
              <strong data-id="element-1087">48+ Hours Notice:</strong> No charge will be applied if
              you cancel or reschedule with at least 48 hours' notice.
            </li>
            <li data-id="element-1088">
              <strong data-id="element-1089">24-48 Hours Notice:</strong> 50% of the lesson fee will be
              charged if you cancel or reschedule with between 24 and 48 hours'
              notice.
            </li>
            <li data-id="element-1090">
              <strong data-id="element-1091">Less than 24 Hours Notice:</strong> The full lesson fee
              will be charged if you cancel or reschedule with less than 24
              hours' notice.
            </li>
            <li data-id="element-1092">
              <strong data-id="element-1093">No Show:</strong> If you fail to attend a scheduled lesson
              without any prior notice, the full lesson fee will be charged.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1094">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1095">
            Intensive Courses
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1096">
            <li data-id="element-1097">
              <strong data-id="element-1098">7+ Days Notice:</strong> Full refund less a £50
              administration fee.
            </li>
            <li data-id="element-1099">
              <strong data-id="element-1100">3-7 Days Notice:</strong> 50% of the course fee will be
              retained.
            </li>
            <li data-id="element-1101">
              <strong data-id="element-1102">Less than 3 Days Notice:</strong> No refund will be
              provided.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1103">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1104">
            Driving Tests
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1105">
            <li data-id="element-1106">
              <strong data-id="element-1107">Test Booking Service:</strong> Our £110 test booking
              service is non-refundable once the test has been booked.
            </li>
            <li data-id="element-1108">
              <strong data-id="element-1109">Test Day Cancellation:</strong> If you cancel the use of
              the instructor's car for your test with less than 3 working days'
              notice, the full fee will still be charged.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1110">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1111">
            Exceptional Circumstances
          </h2>
          <p data-id="element-1112">
            We understand that exceptional circumstances such as illness,
            emergencies, or bereavement may arise. In such cases, please contact
            us as soon as possible, and we will do our best to accommodate your
            situation. Supporting documentation may be requested.
          </p>
        </section>
        <section className="mb-8" data-id="element-1113">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1114">
            Instructor Cancellations
          </h2>
          <p className="mb-4" data-id="element-1115">
            In the rare event that your instructor needs to cancel a lesson, we
            will:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1116">
            <li data-id="element-1117">Notify you as soon as possible</li>
            <li data-id="element-1118">Offer an alternative date and time</li>
            <li data-id="element-1119">
              If no suitable alternative can be found, provide a full refund for
              that lesson
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1120">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1121">
            Weather Conditions
          </h2>
          <p className="mb-4" data-id="element-1122">
            For safety reasons, lessons may need to be cancelled due to severe
            weather conditions (e.g., heavy snow, ice, fog, or flooding). In
            such cases:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1123">
            <li data-id="element-1124">
              The instructor will make the final decision based on safety
              considerations
            </li>
            <li data-id="element-1125">No cancellation fee will be charged</li>
            <li data-id="element-1126">
              We will work with you to reschedule the lesson as soon as possible
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1127">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1128">
            Payment and Refunds
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1129">
            <li data-id="element-1130">
              Refunds for eligible cancellations will be processed within 10
              working days
            </li>
            <li data-id="element-1131">
              Refunds will be made using the same payment method used for the
              original transaction
            </li>
            <li data-id="element-1132">
              Block booking discounts may be adjusted if cancellations reduce
              the number of lessons below the threshold for the discount
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1133">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1134">
            Contact Us
          </h2>
          <p className="mb-4" data-id="element-1135">
            If you need to cancel or reschedule a lesson, please contact us as
            soon as possible:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1136">
            <li data-id="element-1137">Phone: 07481 300 600</li>
            <li data-id="element-1138">Email: info@northamptondrivingschool.co.uk</li>
          </ul>
        </section>
        <p data-id="element-1139">
          This cancellation policy is effective from January 1, 2023, and may be
          subject to change. Any changes will be communicated to existing
          students and updated on our website.
        </p>
      </div>
    </div>;
};
export default CancellationPage;